module.exports = __webpack_public_path__ + "img/cocktail.d563dac4.svg";